export default __webpack_public_path__ + "static/media/fitCentral.b15a9491.PNG";